import { ContactModel, ContactTimelineModel } from '@/types';
import { BaseService } from '@/services';
import { AxiosRequestConfig } from 'axios';

class ContactService extends BaseService<ContactModel> {
    async getTimeline<ResponseT = ContactTimelineModel>(
        contactId: number,
        config?: AxiosRequestConfig,
    ) {
        return this.http.get<ResponseT>(`${this.route}/${contactId}/timeline`, config);
    }
}

export default new ContactService('contacts');
